import React 			from 'react';
import PropTypes 	from 'prop-types';
import BLComponent from '../core/_BLComponent.jsx';

//this.props.classes	: string of classes

export default class FollowButton extends BLComponent {
	constructor(props) {
		super(props);
	}

	render() {
		const {classes = '', isFollowing, onClickFunc} = this.props;

		return (
			<button className={"btn btn-follow " + classes + (isFollowing ? ' btn-follow--is-following ' : '')} onClick={() => onClickFunc()}>
				<i className={"btn-follow__icon far" + (isFollowing ? ' fa-minus' : ' fa-plus')}/>
				{isFollowing ? $T("UNFOLLOW") : $T("FOLLOW")}
			</button>
		);
	}
}

FollowButton.propTypes = {
		classes: PropTypes.string
	,	isFollowing: PropTypes.bool
	, onClickFunc: PropTypes.func.isRequired
}

var $T = BLComponent.createTextMap( 
	{
		"FOLLOW":
		{
			"en":	"Follow"
		,	"kr":	""
		,	"es":	"Seguir"
		}
	,	"UNFOLLOW":
		{
			"en":	"Unfollow"
		,	"kr":	""
		,	"es":	"Siguiendo"
		}
	}
);